import { jwtDecode } from "jwt-decode";
import type { DecodedJwt } from "./types";

/** Decode a JWT without verifying the signature (server enforces signing).
 *
 * Returns null for malformed tokens. The client uses the decoded payload
 * for routing/UX decisions (e.g., redirect to /change-password when
 * scope=password_change) but never for security decisions — AppSync
 * verifies on every request.
 */
export function decode(token: string | null | undefined): DecodedJwt | null {
  if (!token) return null;
  try {
    const stripped = token.replace(/^Bearer\s+/i, "");
    return jwtDecode<DecodedJwt>(stripped);
  } catch {
    return null;
  }
}

/** Is the token's exp claim in the past? Treats unknown/malformed as expired. */
export function isExpired(decoded: DecodedJwt | null): boolean {
  if (!decoded || typeof decoded.exp !== "number") return true;
  return decoded.exp * 1000 < Date.now();
}
